import React from 'react';
import BlockRenderer from '../blocks/BlockRenderer';

const CheckpointDirectionsPage = ({ page, lesson }) => {
  const iconColor = page.icon?.color || 
    (page.checkpointId && lesson?.checkpoints?.find(c => c.id === page.checkpointId)?.icon?.color) || 
    'blue';
  const isGreen = iconColor === 'green';
  
  return (
    <div>
      {page.title && (
        <div className="flex items-center gap-3 mb-6">
          {(page.icon?.show !== false) && (
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              isGreen ? 'bg-green-100' : 'bg-blue-100'
            }`}>
              <svg className={`w-5 h-5 ${isGreen ? 'text-green-600' : 'text-blue-600'}`} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
          )}
          <h2 className="text-2xl font-bold text-gray-800">{page.title}</h2>
        </div>
      )}
      
      {page.blocks?.map(block => (
        <BlockRenderer key={block.id} block={block} />
      ))}
    </div>
  );
};

export default CheckpointDirectionsPage;

